import { _ as _copyObject } from './_copyObject.mjs';
import { _ as _getSymbolsIn } from './_getSymbolsIn.mjs';

var copyObject = _copyObject,
    getSymbolsIn = _getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn;

export { _copySymbolsIn as _ };
